import { EntityBase } from './EntityBase';

import { Validator } from 'breeze-client';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

export class ExposureSurveyMaterialMostRecent extends EntityBase {

   /// <code> Place custom code between <code> tags
   
   /// </code>

   // Generated code. Do not place code below this line.
   materialId: number;
   realCASNumber: string;
   rIFMId: string;
   synonymWord: string;
   exposureSurveyId: number;
   exposureSurveyDate: Date;
   exposureSurveyNumber: number;
}

